const guardRoute = (to, from, next) => {
  // Resource: https://goo.gl/MsK7bY
  // Check if user is authenticated

  const isAuthenticated = localStorage.getItem('token') !== null

  // Allow Anonymous
  if (to.matched.some(record => record.meta.allowAnonymous)) {
    next()
  // Not authenticated
  } else if (!isAuthenticated) {
    next('/login')
  // Authenticated
  } else if (isAuthenticated) {
    next()
  }
}

export default guardRoute



// WEBPACK FOOTER //
// ./src/router/guard-route.js